import {HeaderImages} from "../StaticImages";


export const CarouselSlides = HeaderImages.map(img => ({
	img: img,
	desc: "",
}))